import React from "react";
import { Paper, Typography, Chip, Button, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { adduser } from "../redux/actionTypes";

const useStyles = makeStyles((theme) => ({
	root: {
		// margin: "3rem auto",
		padding: "5rem auto",
		maxWidth: "500px",
		textAlign: "center",
		// backgroundColor: "blue",
	},
	input: { margin: theme.spacing(2) },
}));

const Home = ({ adduser, history }) => {
	let [name, setName] = React.useState("");
	let { root, input } = useStyles();
	return (
		<div className={root}>
			<Typography style={{ paddingTop: "3rem" }} variant="h5">
				Welcome to ChatApp
			</Typography>
			<TextField
				className={input}
				required
				onChange={(e) => {
					setName(e.target.value);
				}}
				id="outlined-basic"
				label="Enter your Name"
				value={name}
				style={{ paddingBottom: "3rem" }}
				onKeyUp={(e) => {
					if (e.keyCode === 13) {
						adduser(name);
						history.push("/chat");
					}
				}}
			/>
		</div>
	);
};

const mapDispatch = (dispatch) => ({
	adduser: (user) => dispatch(adduser(user)),
});
export default connect(undefined, mapDispatch)(Home);
